import React from "react";
import LegalPage from "./LegalPage";
import useContactInfo from "./useContactInfo";

export default function Terms() {
  const { contactEmail } = useContactInfo();
  return (
    <LegalPage testId="terms-page" title="Terms of Service" updated="February 9, 2026">
      <p>These Terms govern your use of the ZA Player Pro Web client and the website at <a href="https://zaplayerpro.club">zaplayerpro.club</a>. By installing the app or claiming a trial you agree to be bound by them.</p>

      <h2>1. What ZA Player Pro is</h2>
      <p>ZA Player Pro is a <strong>media player</strong>. It plays media you already have access to, from an origin you supply yourself. <strong>We do not host, index, promote, or resell any media content.</strong> Everything you watch comes from an origin you configured yourself and pays for yourself.</p>

      <h2>2. Your activation key</h2>
      <p>A ZA Player Pro activation key unlocks the player on one device. A monthly, yearly, or lifetime key is not a content subscription — it is a licence to use the software. Trial keys are one-per-device.</p>

      <h2>3. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the app to distribute media you do not have the right to distribute.</li>
        <li>Violate anyone else&rsquo;s intellectual property, privacy, or dignity.</li>
        <li>Circumvent the single-device binding of your activation key.</li>
        <li>Reverse-engineer, decompile, or extract the source code.</li>
        <li>Attack, overload, or otherwise harm our infrastructure.</li>
        <li>Resell activation keys outside of the official reseller programme.</li>
      </ul>

      <h2>4. Payments and refunds</h2>
      <p>Payments made via PayFast, PayPal or Stripe are non-refundable once the key is issued, except where consumer-protection law requires otherwise (e.g. the seven-day cooling-off under the South African Consumer Protection Act). Apple in-app purchases are governed by Apple&rsquo;s refund policy.</p>

      <h2>5. Availability</h2>
      <p>We aim for the website and activation service to be reachable 24/7 but do not promise a specific uptime. The player itself runs on your device and does not require our servers to be online in order to play media you already configured.</p>

      <h2>6. Warranty disclaimer</h2>
      <p>The app is provided <strong>&ldquo;as is&rdquo; and &ldquo;as available&rdquo;</strong>. We disclaim all warranties, express or implied, to the maximum extent permitted by law.</p>

      <h2>7. Limit of liability</h2>
      <p>Our total liability to you for any claim is limited to the amount you paid us for the activation key in question in the preceding twelve months.</p>

      <h2>8. Governing law</h2>
      <p>These Terms are governed by the laws of the Republic of South Africa. Disputes will be heard by the courts of Pretoria.</p>

      <h2>9. Changes</h2>
      <p>Material changes will be surfaced in the app on next launch.</p>

      <h2>10. Contact</h2>
      <p>Email <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.</p>
    </LegalPage>
  );
}
